import Constants from 'constants';

const _defaultState = {
    fetchingBookingInfo: false,
    bookingInfo: []
},

    hotelRecentBooking = (state = _defaultState, action) => {
        try {
            const { type, payload } = action;
            switch (type) {
                case Constants.actions.SEARCH.BOOKING_INFO:
                    return {
                        ...state,
                        bookingInfo: payload,
                        fetchingBookingInfo: false
                    }
                case Constants.actions.SEARCH.FETCHING_BOOKING:
                    return {
                        ...state,
                        fetchingBookingInfo: true
                    }
                default:
                    return state;
            }
        } catch (error) {
            return _defaultState;
        }
    };

export default hotelRecentBooking;
